/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_No_PointsInputs */

const vi_grower_area_no_points = /** @type {(inputs: Grower_Area_No_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có điểm nào. Bấm bản đồ để thêm.`)
};

/**

* @param {Grower_Area_No_PointsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_no_points = /** @type {((inputs?: Grower_Area_No_PointsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_No_PointsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_no_points(inputs)
});